import { render, staticRenderFns } from "./UserCompetitionsPast.vue?vue&type=template&id=094eef3f&scoped=true&"
import script from "./UserCompetitionsPast.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionsPast.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionsPast.vue?vue&type=style&index=0&id=094eef3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094eef3f",
  null
  
)

export default component.exports